import React from 'react';
import {
    Create,
    Datagrid,
    DateField,
    Edit,
    Filter,
    List,
    required,
    SearchInput,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
} from 'react-admin';

const roleChoices = [
    { id: 'admin', name: 'Admin' },
    { id: 'superadmin', name: 'Super Admin' },
];

const BoAdminFilter = (props) => (
    <Filter {...props}>
        <SearchInput source="search" alwaysOn />
    </Filter>
);

export const BoAdminList = (props) => (
    <List {...props} filters={<BoAdminFilter />} sort={{ field: 'email', order: 'ASC' }}>
        <Datagrid rowClick="edit">
            <TextField source="email" />
            <TextField source="role" />
            <DateField source="created_at" label="Created" showTime />
            <TextField source="created_by" label="Created by" />
            <DateField source="updated_at" label="Updated" showTime />
            <TextField source="updated_by" label="Updated by" />
            <TextField source="note" />
        </Datagrid>
    </List>
);

export const BoAdminCreate = (props) => (
    <Create {...props}>
        <SimpleForm initialValues={{ role: 'admin' }}>
            <TextInput source="email" validate={[required()]} />
            <SelectInput source="role" choices={roleChoices} validate={[required()]} />
            <TextInput source="note" multiline fullWidth />
        </SimpleForm>
    </Create>
);

export const BoAdminEdit = (props) => (
    <Edit undoable={false} {...props}>
        <SimpleForm>
            <TextField source="email" />
            <SelectInput source="role" choices={roleChoices} validate={[required()]} />
            <TextInput source="note" multiline fullWidth />
            <DateField source="created_at" label="Created" showTime />
            <TextField source="created_by" label="Created by" />
            <DateField source="updated_at" label="Updated" showTime />
            <TextField source="updated_by" label="Updated by" />
        </SimpleForm>
    </Edit>
);
